import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationChallengeTotalActivityNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M12 1C4.654 1 .924 3.777.407 4.193A1.092 1.092 0 000 5.046V13c0 3.965 3.026 6.685 5.766 8.35 2.792 1.698 5.639 2.521 5.941 2.607a1.08 1.08 0 00.586 0c.302-.086 3.149-.909 5.941-2.606C20.974 19.685 24 16.965 24 13V5.045c0-.31-.132-.63-.407-.852C23.076 3.777 19.345 1 12 1zM2 13V5.506C3.019 4.82 6.265 3 12 3s8.981 1.82 10 2.506V13c0 2.853-2.192 5.053-4.805 6.642-2.19 1.331-4.438 2.083-5.195 2.316-.757-.233-3.006-.985-5.195-2.316-1.047-.637-2.027-1.372-2.825-2.208L9 12.414l2.293 2.293a1 1 0 001.414 0l4.879-4.879-.283 1.98 1.98.283.707-4.95a1 1 0 00-1.131-1.13l-4.95.706.283 1.98 1.98-.283L12 12.586l-2.293-2.293a1 1 0 00-1.414 0L2.765 15.82C2.282 14.963 2 14.024 2 13z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationChallengeTotalActivityNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationChallengeTotalActivityNormalSmall;
